module.exports = __webpack_public_path__ + "img/insert.f702e52c.png";